import { Box, BoxProps } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography, TypographyTitle, TypographyProps } from 'shared/mui/Typography';
import { TypographySize } from 'shared/mui/Typography/TypographyTitle/TypographyTitle';

import { ActionsStyled, CardHeaderStyled } from './CardHeader.styled';

export type CardHeaderProps = {
  title: React.ReactNode;
  description?: string;
  appendActions?: (React.ReactElement | false) | (React.ReactElement | false)[];
  prependActions?: (React.ReactElement | false) | (React.ReactElement | false)[];
  titleSize?: TypographySize;
  actionsProps?: BoxProps;
  descriptionProps?: TypographyProps;
} & Omit<BoxProps, 'title'>;

export const CardHeader: React.FC<CardHeaderProps> = ({
  description,
  title,
  titleSize,
  descriptionProps,
  prependActions,
  appendActions,
  ...restProps
}: CardHeaderProps) => (
  <CardHeaderStyled {...restProps}>
    <Box flexDirection="column">
      <Stack direction="row" gap={1}>
        {prependActions && prependActions}
        <TypographyTitle size={titleSize}>{title}</TypographyTitle>
      </Stack>
      {description && (
        <Typography fontSize={14} sx={{ color: 'rgba(0, 0, 0, 0.6)' }} {...descriptionProps}>
          {description}
        </Typography>
      )}
    </Box>
    <ActionsStyled>{appendActions && appendActions}</ActionsStyled>
  </CardHeaderStyled>
);
